<section class="mt-2 grid gap-2">
  <h2 class="m-0 text-xl font-semibold leading-tight text-text">
    My Numerons - {{ topicTitle() }}
  </h2>
  <hr class="mb-3 border-0 border-t border-subtle" />

  @if (isLoading()) {
    <p class="text-sm text-text-muted">Loading your numerons...</p>
  } @else if (hasError() && collections().length === 0) {
    <p class="text-sm text-text-muted">
      Your numerons for this topic are unavailable right now. Please try again.
    </p>
  } @else if (collections().length === 0) {
    <p class="text-sm text-text-muted">You have not posted any numerons for this topic yet.</p>
  } @else {
    <div appOrderedMasonry>
      @for (collection of collections(); track trackByCollectionId($index, collection)) {
        <div appOrderedMasonryItem>
          @if (collection.isCollection) {
            <app-collection-feed-card
              [collection]="collection"
              [editReturnUrl]="editReturnUrl()"
              [isMyNumerons]="true"
              [isMyNumeronsByTopic]="true"
            ></app-collection-feed-card>
          } @else if (collection.numerons[0]; as numeron) {
            <app-numeron-card
              [editReturnUrl]="editReturnUrl()"
              [isMyNumerons]="true"
              [isMyNumeronsByTopic]="true"
              [numeron]="numeron"
              [numeronCollection]="collection"
              displayMode="feed"
            ></app-numeron-card>
          }
        </div>
      }
    </div>
  }

  @if (hasError() && collections().length > 0) {
    <p class="text-sm text-text-muted">More content could not be loaded. Please try again.</p>
  }

  @if (isLoadingMore()) {
    <p class="text-sm text-text-muted">Loading more...</p>
  }

  @if (hasMore()) {
    <div
      appInfiniteScrollSentinel
      [disabled]="isLoading() || isLoadingMore() || hasError()"
      (reached)="loadMore()"
      class="h-4"
      aria-hidden="true"
    ></div>
  }
</section>
